<template>
  <div class="container">
    <div class="header-title">
      <el-button type="primary" size="mini" @click="pullModel">拉取模型</el-button>
      <el-button type="primary" size="mini" @click="getList">刷新</el-button>
    </div>
    <vvTable
      :data="moduleList"
      :config="tableConfig"
      :height="600"
    >
      <template slot-scope="scope" slot="version_desc_slot">
        {{scope.row.version_desc ? scope.row.version_desc : '-'}}
      </template>
      <template slot-scope="scope" slot="date_slot">
        {{scope.row.add_ts | tsToDate}}
      </template>
      <template slot-scope="scope" slot="desc_slot">
        {{scope.row.desc ? scope.row.desc : '-'}}
      </template>
      <template slot-scope="scope" slot="state_slot">
        <el-tag type="success" v-if="scope.row.is_published === '1'" size="mini">已发布</el-tag>
        <el-tag type="danger" v-else size="mini">未发布</el-tag>
      </template>
      <template slot-scope="scope" slot="event_slot">
        <publishButton :moduleType="moduleType" :module_uuid="scope.row.model_uuid" @completed="getList"></publishButton>
        &nbsp;&nbsp;
        <viewPublish :id="scope.row.model_uuid" v-if="scope.row.is_published === '1'" :module-type="moduleType"></viewPublish>
        &nbsp;&nbsp;
        <el-button type="text" @click="copy(scope.row.url)" size="mini">复制链接</el-button>
      </template>
    </vvTable>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import viewPublish from '_c/viewPublish';
import vvTable from 'vue-virtual-table';
import {apiGetFoodModelList, apiPullFoodModel} from '@/api';
import publishButton from './publishButton';

export default {
  name: 'zhiyanWssAdmin',
  components: {
    vvTable,
    publishButton,
    viewPublish
  },
  data () {
    return {
      moduleType: 3,
      moduleList: []
    };
  },
  mounted () {
    this.getList();
  },
  methods: {
    ...mapMutations([
      'setSubTitle'
    ]),
    copy (text) {
      this.$copyText(text).then((e) => {
        this.$message.success('复制成功');
      }).catch((e) => {
        this.console.log(e);
        this.$message.error('复制失败' + e);
      });
    },
    async pullModel () {
      try {
        await apiPullFoodModel();
        this.getList();
      } catch (e) {
        this.$message.error('拉取失败' + e.message);
      }
    },
    async getList () {
      try {
        const res = await apiGetFoodModelList();
        this.moduleList = res.model_info_list;
      } catch (e) {
        this.$message.error('获取菜品模型列表失败' + e.message);
      }
    },
    ...mapActions([])
  },
  computed: {
    ...mapGetters(['api_version_list']),
    tableConfig () {
      return [
        { prop: "version", name: "版本号" },
        { prop: "_action", name: "更新日志", actionName: "version_desc_slot" },
        { prop: "_action", name: "上传日期", actionName: "date_slot" },
        { prop: "_action", name: "模块备注", actionName: "desc_slot", width: 300 },
        { prop: "_action", name: "是否发布", actionName: "state_slot", width: 100 },
        { prop: "_action", name: "操作", actionName: "event_slot", width: 200 }
      ];
    }
  },
  watch: {}
};
</script>
<style scoped lang="scss">
  .container {
    position: relative;
    .header-title {
      position: absolute;
      top: -90px;
      left: 200px;
      z-index: 1000;
    }
  }
</style>
